import React from "react";
import Grow from "@mui/material/Grow";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import Addicon from "@mui/icons-material/Add";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Upload2LineIcon from "remixicon-react/Upload2LineIcon";
import Download2LineIcon from "remixicon-react/Download2LineIcon";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";

import { Button, Import, Modal } from "$components";
import useProductImport from "../hooks/useProductImport";
import { useStyles } from "../styles/ProductImport.styles";

type Props = {
  addToCart: any;
  companyId: string;
};

function ProductImportButton({ addToCart, companyId }: Props) {
  const classes = useStyles();

  const {
    anchorRef,
    isImportPopinOpen,
    isMenuOpened,
    errorImport,
    totalImportSuccess,
    isImportLoading,
    isImportFinished,

    handleToggle,
    handleClose,
    downloadTemplatePanier,
    handleCLickOnImportFile,
    handleCancelImportDialog,
    handleValidateImportFile,
    handleImportSuccess,
    onError,
  } = useProductImport({ addToCart, companyId });

  // Fixed: Proper type for the ClickAwayListener handler
  const handleClickAway = React.useCallback(
    (event: any) => {
      handleClose(event);
    },
    [handleClose]
  );

  return (
    <>
      {/* Fixed: Changed innerRef to ref */}
      <Button ref={anchorRef} color="secondary" onClick={handleToggle}>
        <Addicon />
        Ajout produits en masse
      </Button>
      <Popper
        open={isMenuOpened}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-end"
        style={{ zIndex: 10000 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={classes.MenuContainer} elevation={3}>
              {/* Fixed: Using the properly typed handler */}
              <ClickAwayListener onClickAway={handleClickAway}>
                <MenuList autoFocusItem={false} id="menu-list-grow">
                  <MenuItem
                    component="a"
                    className={classes.menuItem}
                    onClick={downloadTemplatePanier}
                  >
                    <ListItemIcon>
                      <Upload2LineIcon className={classes.uploadIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Exporter un template" />
                  </MenuItem>
                  <MenuItem
                    component="a"
                    className={classes.menuItem}
                    onClick={handleCLickOnImportFile}
                  >
                    <ListItemIcon>
                      <Download2LineIcon className={classes.uploadIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Import en masse" />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <Modal
        open={isImportPopinOpen}
        onCancel={handleCancelImportDialog}
        onValidate={handleValidateImportFile}
        title={
          errorImport.length > 0
            ? "Attention"
            : "Ajouter des produits du catalogue"
        }
        textValidate={
          errorImport.length > 0
            ? "Ok"
            : isImportFinished
            ? "Continuer"
            : "Enregistrer"
        }
        isLoading={isImportLoading}
      >
        <div>
          {!isImportFinished && (
            <Import
              importType="panier"
              className={classes.paperModal}
              onImportSuccess={handleImportSuccess}
              onImportError={onError}
              mainErrorMessage={errorImport}
            />
          )}
          {isImportFinished && (
            <div>
              <Alert severity={totalImportSuccess === 0 ? "error" : "success"}>
                {totalImportSuccess === 0 &&
                  "Aucune nouvelle référence va être ajoutée à votre panier"}
                {totalImportSuccess === 1 &&
                  `${totalImportSuccess} nouvelle référence va être ajoutée à votre panier`}
                {totalImportSuccess > 1 &&
                  `${totalImportSuccess} nouvelles références vont être ajoutées à votre panier`}
              </Alert>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

export default ProductImportButton;
